export default __webpack_public_path__ + "static/matic-diamond-be9bd5fc182afdafcfa81dcd7234dca7.gif";